module.exports = __webpack_public_path__ + "img/jr-2.ddd517b1.jpg";